import { render, staticRenderFns } from "./FollowUpTemplateEdit.vue?vue&type=template&id=1f5c08e9&"
import script from "./FollowUpTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./FollowUpTemplateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports